module.exports = __webpack_public_path__ + "img/shidu0.gif";